'use client';

import { PegResult } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

interface ResultsDisplayProps {
  result: PegResult;
  translations: ToolsTranslations['peg'];
  pricePerShare: number;
  epsLatest: number;
  epsPrevious: number;
  currency: string;
}

export default function ResultsDisplay({ result, translations, pricePerShare, epsLatest, epsPrevious }: ResultsDisplayProps) {
  return (
    <div className="space-y-3">
      <div className="p-4 bg-blue-50 rounded-lg border border-blue-100">
        <div className="text-sm text-gray-600">{translations.resultLabel}</div>
        <div className="text-3xl font-bold text-blue-900">
          {result.peg !== null ? `${result.peg.toFixed(2)}` : '—'}
        </div>
        {!result.isValid && (
          <div className="text-xs text-red-600 mt-2">
            {result.message ?? translations.invalid.generic}
          </div>
        )}
      </div>

      {result.isValid && result.peg !== null && (
        <div className="p-4 bg-gray-50 rounded-lg border border-gray-200">
          <p className="text-sm font-medium text-gray-700 mb-3"><b>{translations.additionalInfo.title}</b></p>
          <div className="space-y-2 text-sm">
            <div className="flex justify-between">
              <span className="text-gray-600">{translations.additionalInfo.pricePerShare}:</span>
              <span className="font-medium">{pricePerShare.toLocaleString()} {translations.currencySuffix}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600">{translations.additionalInfo.epsLatest}:</span>
              <span className="font-medium">{epsLatest.toLocaleString()} {translations.currencySuffix}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600">{translations.additionalInfo.epsPrevious}:</span>
              <span className="font-medium">{epsPrevious.toLocaleString()} {translations.currencySuffix}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600">{translations.additionalInfo.pe}:</span>
              <span className="font-medium">{result.pe?.toFixed(2)}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600">{translations.additionalInfo.growthPercent}:</span>
              <span className="font-medium">{result.growthPercent?.toFixed(2)}%</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600">{translations.additionalInfo.interpretation}:</span>
              <span className="font-medium text-blue-600">{result.interpretation}</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}


